import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";

import { Row, Col, Form, InputGroup, Modal, Container } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import { VehicleCategory } from "../../../../utils/apis/masters/masters";
import { Context } from "../../../../utils/context";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
library.add(fas);
const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [vehicleCategort, setVehicleCategory] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const GetAllCategory = async () => {
    const response = await VehicleCategory();

    if (response?.success) {
      setVehicleCategory(
        await Select2Data(response?.data, "vehicle_category_id")
      );
    }
  };

  useEffect(() => {
    GetAllCategory();
  }, []);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append(
        "vehicle_category_id",
        data?.vehicle_category_id?.value
      );
      DataToSend.append("name", data?.name);
      DataToSend.append("fare", data?.fare);
      DataToSend.append("capacity", data?.capacity);
      DataToSend.append("image", data?.image[0]);
      const response = await postData(`/masters/vehicle`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [charCount, setCharCount] = useState(0);
  const maxCharLimit = 100;

  const handleInputChange = (e) => {
    setCharCount(e.target.value.length);
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add User Help Type</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded ">
            <Card.Body>
              <Card.Title>Add Vehicle </Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={() => handleSubmit(onSubmit)}
                            role="form"
                            className="blogfeedclass"
                          >
                            <Row>
                              <Col
                                lg={8}
                                md={10}
                                className=" mx-auto Add-content"
                              >
                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label>
                                          Vehicle Category
                                        </Form.Label>
                                        <Controller
                                          name="vehicle_category_id" // name of the field
                                          {...register("vehicle_category_id", {
                                            required: "Select Vehicle Category",
                                          })}
                                          control={control}
                                          render={({ field }) => (
                                            <Select
                                              styles={{
                                                control: (baseStyles) => ({
                                                  ...baseStyles,
                                                  borderColor:
                                                    errors.vehicle_category_id
                                                      ? "red"
                                                      : baseStyles,
                                                }),
                                              }}
                                              {...field}
                                              options={vehicleCategort}
                                            />
                                          )}
                                        />
                                        {errors.vehicle_category_id && (
                                          <span className="text-danger">
                                            {errors.vehicle_category_id.message}
                                          </span>
                                        )}
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Group>
                                          <InputGroup>
                                            <Form.Control
                                              type="text"
                                              name="name"
                                              placeholder="Name"
                                              className={classNames("", {
                                                "is-invalid": errors?.name,
                                              })}
                                              {...register("name", {
                                                required: "Name is required",
                                                maxLength: {
                                                  value: maxCharLimit,
                                                  message: `Name cannot exceed ${maxCharLimit} characters`,
                                                },
                                              })}
                                              maxLength={maxCharLimit}
                                              onChange={handleInputChange}
                                            />
                                          </InputGroup>
                                          <div className="text-end">
                                            <small>
                                              {maxCharLimit} characters Limit{" "}
                                            </small>
                                          </div>

                                          {errors.name && (
                                            <span className="text-danger">
                                              {errors.name.message}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label>
                                          Fare Per KM (in ₹)
                                        </Form.Label>
                                        <Form.Group>
                                          <InputGroup>
                                            <Form.Control
                                              type="number"
                                              name="fare"
                                              placeholder="Fare"
                                              min="0"
                                              className={classNames("", {
                                                "is-invalid": errors?.fare,
                                              })}
                                              {...register("fare", {
                                                required: "Fare is required",
                                                min: {
                                                  value: 0,
                                                  message:
                                                    "Fare cannot be negative",
                                                },
                                              })}
                                            />
                                          </InputGroup>
                                          <div className="text-end"></div>

                                          {errors.fare && (
                                            <span className="text-danger">
                                              {errors.fare.message}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label>
                                          Capacity (In KG)
                                        </Form.Label>
                                        <Form.Group>
                                          <InputGroup>
                                            <Form.Control
                                              type="number"
                                              name="capacity"
                                              placeholder="Capacity"
                                              min="0"
                                              className={classNames("", {
                                                "is-invalid": errors?.capacity,
                                              })}
                                              {...register("capacity", {
                                                required:
                                                  "Capacity is required",
                                                min: {
                                                  value: 0,
                                                  message:
                                                    "Capacity cannot be negative",
                                                },
                                              })}
                                            />
                                          </InputGroup>
                                          <div className="text-end"></div>

                                          {errors.capacity && (
                                            <span className="text-danger">
                                              {errors.capacity.message}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                {/* New field for uploading an image */}
                                <Col md={6}>
                                  <div className="main-form-section mt-3">
                                    <Form.Group>
                                      <div className="text-center">
                                        <Form.Label>Image</Form.Label>
                                      </div>
                                      <InputGroup>
                                        <Form.Control
                                          type="file"
                                          name="image"
                                          placeholder="Image"
                                          className={classNames("", {
                                            "is-invalid": errors?.image,
                                          })}
                                          {...register("image", {
                                            required: "Image is required",
                                          })}
                                          accept="image/*"
                                          onChange={handleImageChange}
                                        />
                                      </InputGroup>
                                      {errors.image && (
                                        <span className="text-danger">
                                          {errors.image.message}
                                        </span>
                                      )}
                                    </Form.Group>
                                    {imagePreview && (
                                      <div className="mt-2">
                                        <img
                                          src={imagePreview}
                                          alt="Category Preview"
                                          style={{ maxWidth: "100px" }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </Col>
                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>
                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit(onSubmit)}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
